import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import FAQSection from '../components/FAQSection';
import { advantages, bonuses, games, faqs, heroImages } from '../mockData';
import { Shield, Gamepad2, Zap, Gift, Headphones, Smartphone, Star, TrendingUp, ArrowRight, ChevronDown, ChevronUp } from 'lucide-react';

const Homepage = () => {
  const [isContentExpanded, setIsContentExpanded] = useState(false);

  useEffect(() => {
    document.title = 'Robocat Casino Erfahrungen 2025 | Robocat Casino Bewertung Deutschland';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Robocat Casino Erfahrungen & Bewertung für Deutschland ⚡ Robocat Online Casino ✓ Casino Robocat Bonus 500€ + 200 FS ✓ Über 3000 Spiele ✓ Lizenziert & Sicher');
    }
  }, []);

  const getIcon = (iconName) => {
    const icons = {
      Shield: <Shield className="w-8 h-8" />,
      Gamepad2: <Gamepad2 className="w-8 h-8" />,
      Zap: <Zap className="w-8 h-8" />,
      Gift: <Gift className="w-8 h-8" />,
      Headphones: <Headphones className="w-8 h-8" />,
      Smartphone: <Smartphone className="w-8 h-8" />,
    };
    return icons[iconName] || <Star className="w-8 h-8" />;
  };

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative py-20 md:py-32 overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0">
          <img 
            src="https://customer-assets.emergentagent.com/job_seo-casino-portal-1/artifacts/ewqtjeos_1.png" 
            alt="Robocat Casino Banner" 
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-br from-slate-950/95 via-slate-900/90 to-blue-950/95"></div>
        </div>
        
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 bg-cyan-500 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-600 rounded-full blur-3xl"></div>
        </div>
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center space-x-2 bg-cyan-500/10 border border-cyan-500/30 rounded-full px-4 py-2 mb-6">
              <Star className="w-5 h-5 text-yellow-400 fill-yellow-400" />
              <span className="text-cyan-300 font-semibold">Bewertung: 4.8/5 - Top Casino 2025</span>
            </div>
            
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
              Robocat Casino <span className="bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent">Erfahrungen</span> & Bewertung
            </h1>
            
            <p className="text-xl text-gray-300 mb-8 leading-relaxed">
              Entdecken Sie die umfassende Robocat Casino Bewertung für Deutschland. Als führende Plattform für Robocat Erfahrungen präsentieren wir detaillierte Casino Robocat Analysen. Unser Robocat Online Casino Test zeigt über 3.000 Spiele, exklusive Boni und schnelle Auszahlungen. Lesen Sie authentische Robocat Casino Erfahrungen und erfahren Sie alles über das Online Casino Robocat in unserem ausführlichen Robocat Casino Deutschland Review.
            </p>
            
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
              <Button 
                size="lg" 
                className="bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-400 hover:to-blue-500 text-white font-bold px-8 py-6 text-lg shadow-2xl shadow-cyan-500/50 hover:shadow-cyan-500/70 transition-all duration-300"
                onClick={() => alert('Demo: Jetzt spielen')}
              >
                Jetzt spielen
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
              <Button 
                size="lg" 
                variant="outline"
                className="border-2 border-cyan-500 text-cyan-400 hover:bg-cyan-500/10 px-8 py-6 text-lg transition-all duration-300"
                onClick={() => window.scrollTo({ top: document.getElementById('bonuses').offsetTop, behavior: 'smooth' })}
              >
                Bonus sichern
              </Button>
            </div>
            
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl mx-auto">
              <div className="bg-slate-800/50 border border-cyan-500/20 rounded-lg p-4 backdrop-blur-sm">
                <div className="text-3xl font-bold text-cyan-400">500€</div>
                <div className="text-sm text-gray-400">Willkommensbonus</div>
              </div>
              <div className="bg-slate-800/50 border border-cyan-500/20 rounded-lg p-4 backdrop-blur-sm">
                <div className="text-3xl font-bold text-cyan-400">3000+</div>
                <div className="text-sm text-gray-400">Spiele</div>
              </div>
              <div className="bg-slate-800/50 border border-cyan-500/20 rounded-lg p-4 backdrop-blur-sm">
                <div className="text-3xl font-bold text-cyan-400">24/7</div>
                <div className="text-sm text-gray-400">Support</div>
              </div>
              <div className="bg-slate-800/50 border border-cyan-500/20 rounded-lg p-4 backdrop-blur-sm">
                <div className="text-3xl font-bold text-cyan-400">1-2h</div>
                <div className="text-sm text-gray-400">Auszahlung</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Key Advantages */}
      <section className="py-16 bg-gradient-to-b from-slate-900 to-slate-950">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Warum Robocat Casino?</h2>
            <p className="text-gray-400 max-w-2xl mx-auto">Entdecken Sie die Vorteile, die Robocat Casino zur ersten Wahl für deutsche Spieler machen</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
            {advantages.map((advantage, index) => {
              const hoverImages = [
                "https://customer-assets.emergentagent.com/job_seo-casino-portal-1/artifacts/jt9zuysd_1.png",
                "https://customer-assets.emergentagent.com/job_seo-casino-portal-1/artifacts/opdxnjlj_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202025-11-09%20%D0%B2%2006.09.25.png",
                "https://customer-assets.emergentagent.com/job_seo-casino-portal-1/artifacts/88rrf0k5_1.png",
                "https://customer-assets.emergentagent.com/job_seo-casino-portal-1/artifacts/uf2yzgw6_3.png",
                "https://customer-assets.emergentagent.com/job_seo-casino-portal-1/artifacts/wu8bxheb_4.png",
                "https://customer-assets.emergentagent.com/job_seo-casino-portal-1/artifacts/gd9xyc5e_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202025-11-09%20%D0%B2%2005.59.52.png"
              ];
              
              return (
                <Card key={index} className="bg-slate-800/50 border-cyan-500/20 p-6 hover:border-cyan-500/50 transition-all duration-300 hover:shadow-lg hover:shadow-cyan-500/20 backdrop-blur-sm group relative overflow-hidden">
                  <div className="absolute inset-0 opacity-0 group-hover:opacity-10 transition-opacity duration-300">
                    <img 
                      src={hoverImages[index]} 
                      alt={`Robocat Casino ${advantage.title}`}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="relative z-10">
                    <div className="text-cyan-400 mb-4">{getIcon(advantage.icon)}</div>
                    <h3 className="text-xl font-bold text-white mb-3">{advantage.title}</h3>
                    <p className="text-gray-300 leading-relaxed">{advantage.description}</p>
                  </div>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* Bonuses Section */}
      <section id="bonuses" className="py-16 bg-slate-900">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <Gift className="w-12 h-12 text-cyan-400 mx-auto mb-4" />
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Aktuelle Bonusangebote</h2>
            <p className="text-gray-400 max-w-2xl mx-auto">Profitieren Sie von großzügigen Boni und Aktionen bei Robocat Casino</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-6xl mx-auto mb-8">
            {bonuses.filter(b => b.featured).map((bonus, idx) => (
              <Card key={bonus.id} className="bg-gradient-to-br from-slate-800 to-slate-900 border-cyan-500/30 p-8 hover:shadow-2xl hover:shadow-cyan-500/30 transition-all duration-300 relative overflow-hidden flex flex-col">
                <div className="absolute inset-0 opacity-25 brightness-125">
                  <img 
                    src={idx === 0 ? "https://customer-assets.emergentagent.com/job_seo-casino-portal-1/artifacts/lw981dmb_3.png" : "https://customer-assets.emergentagent.com/job_seo-casino-portal-1/artifacts/mo4cn018_4.png"}
                    alt="Robocat Casino Bonus" 
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="relative z-10 flex flex-col flex-grow">
                  <div className="flex items-start justify-between mb-4">
                    <div>
                      <h3 className="text-2xl font-bold text-white mb-2">{bonus.title}</h3>
                      <div className="text-3xl font-bold bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent mb-1">
                        {bonus.amount}
                      </div>
                      {bonus.extras && (
                        <div className="text-cyan-400 font-semibold">{bonus.extras}</div>
                      )}
                    </div>
                    <div className="bg-cyan-500/10 border border-cyan-500/30 rounded-full px-3 py-1 text-cyan-400 text-sm font-semibold">
                      Top Bonus
                    </div>
                  </div>
                  <p className="text-gray-300 mb-4 leading-relaxed">{bonus.description}</p>
                  <div className="text-sm text-gray-400 mb-6 flex-grow">
                    <p><strong>Bedingungen:</strong> {bonus.requirements}</p>
                    <p><strong>Gültig bis:</strong> {bonus.validUntil}</p>
                  </div>
                  <Button 
                    className="w-full bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-400 hover:to-blue-500 text-white font-bold shadow-lg mt-auto"
                    onClick={() => alert('Demo: Bonus aktivieren')}
                  >
                    Bonus aktivieren
                  </Button>
                </div>
              </Card>
            ))}
          </div>
          
          <div className="text-center">
            <Link to="/aktionen">
              <Button size="lg" variant="outline" className="border-cyan-500 text-cyan-400 hover:bg-cyan-500/10">
                Alle Aktionen anzeigen
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Games Preview */}
      <section className="py-16 bg-slate-950">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <Gamepad2 className="w-12 h-12 text-cyan-400 mx-auto mb-4" />
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Beliebte Spiele</h2>
            <p className="text-gray-400 max-w-2xl mx-auto">Entdecken Sie die Top-Slots und Live-Casino-Spiele bei Robocat Casino</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto mb-8">
            {games.slice(0, 3).map((game, idx) => {
              const gameImages = [
                "https://customer-assets.emergentagent.com/job_seo-casino-portal-1/artifacts/pupm5qgo_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202025-11-09%20%D0%B2%2007.02.08.png",
                "https://customer-assets.emergentagent.com/job_seo-casino-portal-1/artifacts/80oa1frj_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202025-11-09%20%D0%B2%2007.02.20.png",
                "https://customer-assets.emergentagent.com/job_seo-casino-portal-1/artifacts/q3kfvt5k_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202025-11-09%20%D0%B2%2007.01.40.png"
              ];
              
              return (
                <Card key={game.id} className="bg-slate-800/50 border-cyan-500/20 overflow-hidden hover:shadow-xl hover:shadow-cyan-500/20 transition-all duration-300 group">
                  <div className="aspect-video relative overflow-hidden">
                    <img 
                      src={gameImages[idx]} 
                      alt={game.name}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 to-transparent"></div>
                  </div>
                  <div className="p-6">
                    <h3 className="text-lg font-bold text-white mb-2">{game.name}</h3>
                    <div className="flex items-center justify-between text-sm mb-3">
                      <span className="text-gray-400">{game.provider}</span>
                      <div className="flex items-center space-x-1">
                        <Star className="w-4 h-4 text-yellow-400 fill-yellow-400" />
                        <span className="text-white font-semibold">{game.rating}</span>
                      </div>
                    </div>
                    <div className="flex items-center justify-between text-sm">
                      <span className="text-gray-400">RTP: <span className="text-cyan-400 font-semibold">{game.rtp}</span></span>
                      <span className="text-gray-400">Volatilität: <span className="text-cyan-400">{game.volatility}</span></span>
                    </div>
                  </div>
                </Card>
              );
            })}
          </div>
          
          <div className="text-center">
            <Link to="/spiele">
              <Button size="lg" variant="outline" className="border-cyan-500 text-cyan-400 hover:bg-cyan-500/10">
                Alle Spiele anzeigen
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* SEO Content with Dropdown - Before FAQs */}
      <section className="py-16 bg-slate-900">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="bg-slate-800/50 border border-cyan-500/20 rounded-2xl overflow-hidden">
              <button
                onClick={() => setIsContentExpanded(!isContentExpanded)}
                className="w-full px-8 py-6 flex items-center justify-between hover:bg-slate-800/70 transition-colors"
              >
                <h2 className="text-2xl md:text-3xl font-bold text-white text-left">
                  Robocat Casino - Die umfassende Bewertung für deutsche Spieler
                </h2>
                {isContentExpanded ? (
                  <ChevronUp className="w-6 h-6 text-cyan-400 flex-shrink-0 ml-4" />
                ) : (
                  <ChevronDown className="w-6 h-6 text-cyan-400 flex-shrink-0 ml-4" />
                )}
              </button>
              
              <div className="px-8 pb-8 space-y-6">
                <p className="text-gray-300 leading-relaxed">
                  Die <strong>Robocat Casino Erfahrungen</strong> zeigen, dass sich diese Plattform seit ihrer Gründung als führendes Online Casino in Deutschland etabliert hat. Unsere ausführliche <strong>Robocat Bewertung</strong> belegt, dass <strong>Casino Robocat</strong> mit über 3.000 Spielen, großzügigen Bonusangeboten und einem starken Fokus auf Spielersicherheit überzeugt...
                </p>
                
                {isContentExpanded && (
                  <div className="space-y-6 animate-in slide-in-from-top duration-300">
                    <img 
                      src="https://customer-assets.emergentagent.com/job_seo-casino-portal-1/artifacts/6nnigv33_2.png" 
                      alt="Robocat Casino Erfahrungen" 
                      className="w-full rounded-lg border border-cyan-500/20 shadow-lg"
                    />
                    
                    <p className="text-gray-300 leading-relaxed">
                      Die <strong>Robocat Casino Bewertung</strong> untersucht alle Aspekte von der Spielauswahl über Zahlungsmethoden bis hin zu Kundensupport und Lizenzierung. Das <strong>Robocat Online Casino</strong> zeichnet sich durch seine futuristische, technologieorientierte Plattform aus, die sowohl Anfängern als auch erfahrenen Spielern ein nahtloses Spielerlebnis bietet.
                    </p>
                    
                    <img 
                      src="https://customer-assets.emergentagent.com/job_seo-casino-portal-1/artifacts/a7rkion4_6.png" 
                      alt="Robocat Online Casino" 
                      className="w-full rounded-lg border border-cyan-500/20 shadow-lg"
                    />
                    
                    <p className="text-gray-300 leading-relaxed">
                      Die <strong>Robocat Casino Deutschland</strong> Plattform verfügt über eine gültige Glücksspiellizenz und verwendet modernste SSL-Verschlüsselungstechnologie. Authentische <strong>Robocat Erfahrungen</strong> bestätigen, dass das <strong>Online Casino Robocat</strong> mit renommierten Spieleanbietern wie Pragmatic Play, Evolution Gaming und Play'n GO zusammenarbeitet.
                    </p>
                    
                    <p className="text-gray-300 leading-relaxed">
                      Ein herausragendes Merkmal in unserer <strong>Robocat Casino Bewertung</strong> ist die schnelle Auszahlungsgeschwindigkeit. Während viele Online-Casinos Spieler tagelang warten lassen, bearbeitet <strong>Casino Robocat</strong> Auszahlungsanfragen innerhalb von 1-2 Stunden für E-Wallets. Diese Effizienz, kombiniert mit dem umfangreichen Bonusprogramm und professionellem deutschsprachigem Kundensupport, macht das <strong>Robocat Casino Online</strong> zur erstklassigen Wahl für deutsche Spieler, wie zahlreiche positive <strong>Robocat Casino Erfahrungen</strong> belegen.
                    </p>
                  </div>
                )}
                
                <button
                  onClick={() => setIsContentExpanded(!isContentExpanded)}
                  className="text-cyan-400 hover:text-cyan-300 font-semibold transition-colors flex items-center space-x-2"
                >
                  <span>{isContentExpanded ? 'Weniger anzeigen' : 'Mehr anzeigen'}</span>
                  {isContentExpanded ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <FAQSection faqs={faqs.homepage} />

      {/* Schema.org Organization Markup */}
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: 'Robocat Casino',
          url: 'https://robocat2.com/de/',
          logo: 'https://bonkku.com/wp-content/uploads/2024/11/robocat-casino-logo-e1730983673466.png',
          description: 'Robocat Casino - Führende Online-Casino-Bewertungsplattform für Deutschland mit über 3.000 Spielen',
          address: {
            '@type': 'PostalAddress',
            streetAddress: 'Alexanderplatz 1',
            addressLocality: 'Berlin',
            postalCode: '10178',
            addressCountry: 'DE',
          },
        })}
      </script>
    </div>
  );
};

export default Homepage;
